// src/components/Profile/WalletStatsCard.js
import React from "react";
import "./ProfileCards.css";
import BarChartComponent from "../Elements/Charts/BarChartComponent";

const WalletStatsCard = ({ stats }) => {
  if (!stats || typeof stats !== "object") {
    return (
      <section className="summary-card summary-card--user">
        <p className="summary-balance-label">Wallet activity</p>
        <div className="summary-chart-body summary-chart-empty">No stats available yet.</div>
      </section>
    );
  }

  const data = Object.entries(stats).map(([month, value]) => ({
    month,
    incomes: value.incomes || 0,
    outcomes: value.outcomes || 0,
  }));

  if (data.length === 0) {
    return (
      <section className="summary-card summary-card--user">
        <p className="summary-balance-label">Wallet activity</p>
        <div className="summary-chart-body summary-chart-empty">No stats available yet.</div>
      </section>
    );
  }

  return (
    <section className="summary-card summary-card--chart">
      <p className="summary-balance-label">Wallet activity</p>
      <div className="summary-chart-body">
        <BarChartComponent data={data} dataKeyX="month" dataKeyY={["outcomes", "incomes"]} />
      </div>
    </section>
  );
};

export default WalletStatsCard;
